import React from 'react';

export default function Email() {
  return (
    <svg
      width='58'
      height='57'
      viewBox='0 0 58 57'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_di_375_4459)'>
        <g clipPath='url(#clip0_375_4459)'>
          <rect
            x='1'
            width='56'
            height='56'
            rx='16'
            fill='url(#paint0_linear_375_4459)'
          />
          <g filter='url(#filter1_dd_375_4459)'>
            <path
              d='M38.3333 38.5003V40.8337H15V22.167C15 20.6503 15.98 19.367 17.3333 18.877V38.5003H38.3333ZM28.86 24.6403C30.225 26.0053 32.4417 26.0053 33.8067 24.6403L42.1017 16.3453C41.46 15.622 40.5383 15.167 39.5 15.167H23.1667C22.1283 15.167 21.2067 15.6337 20.565 16.3453L28.86 24.6403ZM35.4633 26.2853C34.3317 27.417 32.8267 27.9887 31.3333 27.9887C29.84 27.9887 28.3467 27.417 27.2033 26.2853L19.6667 18.7487V36.167H43V18.7487L35.4633 26.2853Z'
              fill='url(#paint1_linear_375_4459)'
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id='filter0_di_375_4459'
          x='0.5'
          y='0'
          width='57'
          height='57'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_375_4459'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_375_4459'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect2_innerShadow_375_4459'
          />
        </filter>
        <filter
          id='filter1_dd_375_4459'
          x='-20'
          y='-12.1015'
          width='98'
          height='99.1015'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='10' />
          <feGaussianBlur stdDeviation='17.5' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_375_4459'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='3.89851' />
          <feGaussianBlur stdDeviation='15' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_375_4459'
            result='effect2_dropShadow_375_4459'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_375_4459'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_375_4459'
          x1='29'
          y1='0'
          x2='29'
          y2='56'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#29282C' />
          <stop offset='1' stopColor='#100F11' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_375_4459'
          x1='14.7837'
          y1='9.89334'
          x2='32.7759'
          y2='38.663'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0.65' />
        </linearGradient>
        <clipPath id='clip0_375_4459'>
          <rect x='1' width='56' height='56' rx='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
